/*!

=========================================================
* Black Dashboard PRO React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
/*eslint-disable*/
import React from "react";
import { NavLink } from "react-router-dom";
import PropTypes from "prop-types";
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";

// reactstrap components
import { Nav, Collapse, Button, Card, CardBody, CardTitle, Modal, ModalHeader, ModalBody } from "reactstrap";
import axios from 'axios';
import { Badge } from 'reactstrap';
import Request from '../../common/Request';
import WithRole from '../../views/FormParts/ButtonWithRole';
import { CONSTRUCTION_REGIST } from '../../variables/codes_map';

var ps;

class Sidebar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ...this.getCollapseStates(props.routes),
      modalRegist: false
    };
    // this.new_arrival_counts_get();
    this.modalRegist = this.modalRegist.bind(this);
    this.transition_regist = this.transition_regist.bind(this);
  }

  // new_arrival_counts_get() {
  //   Request.get('/api/task',{}, res => {
  //     //console.log(res.Data);
  //     this.setState({
  //       new_arrivals_count: res.Data
  //       });
  //   },()=>{},()=>{},true,false)

  // }
  // this creates the intial state of this component based on the collapse routes
  // that it gets through this.props.routes
  getCollapseStates = routes => {
    let initialState = {};
    routes.map((prop, key) => {
      if (prop.collapse) {
        initialState = {
          [prop.state]: this.getCollapseInitialState(prop.views),
          ...this.getCollapseStates(prop.views),
          ...initialState
        };
      }
      return null;
    });
    return initialState;
  };
  // this verifies if any of the collapses should be default opened on a rerender of this component
  // for example, on the refresh of the page,
  // while on the src/views/forms/RegularForms.jsx - route /admin/regular-forms
  getCollapseInitialState(routes) {

    for (let i = 0; i < routes.length; i++) {

      if (routes[i].collapse && this.getCollapseInitialState(routes[i].views)) {
        return true;
      } else if (window.location.href.indexOf(routes[i].path) !== -1) {
        return true;
      }
    }
    return false;
  }
  badge(props) {
    if(!this.props.new_arrivals_count) {
      return '';
    }
    if(!props.badge_key) {
      return '';
    }
    if(props.badge_key in this.props.new_arrivals_count) {
      if(Number(this.props.new_arrivals_count) > 5){
        return (
          <Badge color="red" pill>{this.props.new_arrivals_count[props.badge_key]}</Badge>
        );
      }else{
        return (
          <Badge color="warning" pill>{this.props.new_arrivals_count[props.badge_key]}</Badge>
        );
      }
    }
    return '';
  }
  separater(props){
//    console.log(props.name)
    switch(props.name){
      // case "その他依頼一覧":
      //case "敷金":
      // case "入金管理":
      //case "駐車場マスタ":
      // case "FAX送信":
        // return (<hr className="SideSeparater" />);
      // break;
      case "旧メニュー":
        return (<hr className="SideSeparater" />);
      case "保留":
        return (<hr className="SideSeparater" />);
    }
  }
  // this function creates the links and collapses that appear in the sidebar (left menu)
  createLinks = routes => {
    const { rtlActive } = this.props;
    return routes.map((prop, key) => {
      if (prop.redirect) {
        return null;
      }
      if (!prop.data_view_flag || prop.data_view_flag < 1 || prop.view === false){
        return null;
      }
      if (prop.collapse) {
        var st = {};
        st[prop["state"]] = !this.state[prop.state];
        // console.log(prop);
        return (
          <li
            className={this.getCollapseInitialState(prop.views) ? "active" : ""}
            key={key}
          >
            <a
              href="#pablo"
              data-toggle="collapse"
              aria-expanded={this.state[prop.state]}
              onClick={e => {
                e.preventDefault();
                this.setState(st);
              }}
            >
              {prop.icon !== undefined ? (
                <>
                  {/* <i className={prop.icon} />
                  <p>
                    {rtlActive ? prop.rtlName : prop.name}
                    <b className="caret" />
                  </p> */}
                </>
              ) : (
                <>
                  <span className="sidebar-mini-icon">
                    {rtlActive ? prop.rtlMini : prop.mini}
                  </span>
                  <span className="sidebar-major-item">{this.badge(prop)}</span>
                  <span className="sidebar-normal">
                    {rtlActive ? prop.rtlName : prop.name}
                    <b className="caret" />
                  </span>
                </>
              )}
              
            </a>
            <Collapse isOpen={this.state[prop.state]}>
              <ul className="nav submenu">{this.createLinks(prop.views)}</ul>
            </Collapse>
            {this.separater(prop)}
          </li>
        );
      }
      // 新規登録表示用
      if(prop.path === "new_regist"){
        return (
          <li className={this.activeRoute(prop.path) } key={key}>
            <a>
              <p className="sidebar-mini-text">
                {rtlActive ? prop.rtlMini : prop.mini}
                
                {this.badge(prop)}
              </p>
              <p className="sidebar-long-text" onClick={this.modalRegist}>{rtlActive ? prop.rtlName : prop.name} {this.badge(prop)}</p>
              {this.separater(prop)} 
            </a>
          </li>
        )
      }
      return (
        <li className={this.activeRoute(prop.path) } key={key}>
          <NavLink to={prop.layout + prop.path} activeClassName="" onClick={this.props.closeSidebar}>
            {prop.icon !== undefined ? (
              <>
                {/* <i className={prop.icon} /> */}
                <p className="sidebar-mini-text">
                  {rtlActive ? prop.rtlMini : prop.mini}
                  
                  {this.badge(prop)}
                </p>
                <p className="sidebar-long-text">{rtlActive ? prop.rtlName : prop.name} {this.badge(prop)}</p>
                {this.separater(prop)}                
              </>
            ) : (
              <>
                <span className="sidebar-mini-icon">
                  {rtlActive ? prop.rtlMini : prop.mini}
                </span>
                <span className="sidebar-normal">
                  {rtlActive ? prop.rtlName : prop.name}
                </span>
              </>
            )}
          </NavLink>
        </li>
      );
      
    });
  };
  // verifies if routeName is the one active (in browser input)
  activeRoute = path => {
    let pathname = this.props.location.pathname ? this.props.location.pathname : window.location.pathname;
    return pathname.startsWith(path) ? "active" : "";
  };
  componentDidMount() {
    // if you are using a Windows Machine, the scrollbars will have a Mac look
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(this.refs.sidebar);
    }
  }
  componentWillUnmount() {
    // we need to destroy the false scrollbar when we navigate
    // to a page that doesn't have this component rendered
    if (navigator.platform.indexOf("Win") > -1) {
      ps.destroy();
    }
  }

  // 新規登録モーダル用
  async modalRegist(){
    await this.setState({
      modalRegist: !this.state.modalRegist
    });
    this.dialog_defines();    
  }

  transition_regist(regist_type) {
    this.modalRegist();
    // box_statusは0（検索）
    this.props.history.push(`/construction/add/${regist_type}?box_status=0`);
    location.reload();
  }

  dialog_defines() {
    // ボタン制御の情報(buttons)取得
    let buttons = undefined;
    this.props.routes.map( routes =>{
      if(routes.path === "new_regist"){
        buttons = routes.buttons;
      }
    });
    const ButtonWithRole = WithRole(Button, buttons);
  
    return (
      <>
      <Modal isOpen={this.state.modalRegist} toggle={this.modalRegist} size="lg">
          <ModalHeader className="justify-content-center" toggle={this.modalRegist}>
            新規登録する依頼の種別を選択してください
          </ModalHeader>
          <ModalBody>
          <Card>
            <CardBody>
              <CardTitle tag="h4" className="float-left">駐車場</CardTitle><br /><br /><br />
              <ButtonWithRole button_id="BTN_A1_01_00400" color="info" onClick={()=>{this.transition_regist(CONSTRUCTION_REGIST.FIRST)}}>初回</ButtonWithRole>&nbsp;
              <ButtonWithRole button_id="BTN_A1_01_00410" color="info" onClick={()=>{this.transition_regist(CONSTRUCTION_REGIST.TRANSSHIPMENT)}}>積替用地</ButtonWithRole>
            </CardBody>
          </Card>
          <Card>
            <CardBody>
              <CardTitle tag="h4" className="float-left">その他サービス</CardTitle><br /><br /><br />
              <ButtonWithRole button_id="BTN_A1_01_00420" color="info" onClick={()=>{this.transition_regist(CONSTRUCTION_REGIST.PERMISSION_ROAD_USAGE)}}>道路使用許可</ButtonWithRole>&nbsp;
              <ButtonWithRole button_id="BTN_A1_01_00430" color="info" onClick={()=>{this.transition_regist(CONSTRUCTION_REGIST.STORE_MANUAL)}}>取扱説明書収納</ButtonWithRole>&nbsp;
              <ButtonWithRole button_id="BTN_A1_01_00440" color="info" onClick={()=>{this.transition_regist(CONSTRUCTION_REGIST.RELOCATION_WIRE)}}>電線移設</ButtonWithRole>
            </CardBody>
          </Card>
          <Card>
            <CardBody>
            <Button className="pos_center" onClick={this.modalRegist}>
              キャンセル
            </Button>
            </CardBody>
          </Card>

          </ModalBody>
        </Modal>
      </>
    );
  }

  render() {
    const { activeColor, logo } = this.props;
    let logoImg = null;
    let logoText = null;
    let dialog_defines = this.dialog_defines();
    if (logo !== undefined) {
      if (logo.outterLink !== undefined) {
        logoImg = (
          <a
            href={logo.outterLink}
            className="simple-text logo-mini"
            target="_blank"
            onClick={this.props.closeSidebar}
          >
            <div className="logo-img">
              <img src={logo.imgSrc} alt="react-logo" />
            </div>
          </a>
        );
        logoText = (
          <a
            href={logo.outterLink}
            className="simple-text logo-normal"
            target="_blank"
            onClick={this.props.closeSidebar}
          >
            {logo.text}
          </a>
        );
      } else {
        logoImg = (
          <NavLink
            to={logo.innerLink}
            className="simple-text logo-mini"
            onClick={this.props.closeSidebar}
          >
            <div className="logo-img">
              <img src={logo.imgSrc} alt="react-logo" />
            </div>
          </NavLink>
        );
        logoText = (
          <NavLink
            to={logo.innerLink}
            className="simple-text logo-normal"
            onClick={this.props.closeSidebar}
          >
            {logo.text}
          </NavLink>
        );
      }
    }
    // console.log(this.props.routes)
    // console.log(logo.text);
    return (
      <>
      <div className="sidebar" data={activeColor}>
        <div className="sidebar-wrapper" ref="sidebar">
          {/*logoImg !== null || logoText !== null ? (
            <div className="logo">
              {logoImg}
              {logoText}
            </div>
          ) : null*/}
          <div className="logo">
            <NavLink
              to={"#"}
              className="simple-text logo-mini"
              onClick={this.props.closeSidebar}
            >
              <div className="logo-img">
                <img src={logo.imgSrc} alt="react-logo" />
              </div>
            </NavLink>
            <NavLink
              to={"#"}
              className="simple-text logo-normal"
              onClick={this.props.pushRefreshTaskCount}
            >
              <button color="info" className="btn btn-secondary btn-sm">最新の状態に更新</button>
            </NavLink>
          </div>
          <Nav>{this.createLinks(this.props.routes)}</Nav>
        </div>
      </div>
      {dialog_defines}
      </>
    );
  }
}

Sidebar.propTypes = {
  activeColor: PropTypes.oneOf(["primary", "blue", "green", "orange", "red"]),
  rtlActive: PropTypes.bool,
  routes: PropTypes.array.isRequired,
  logo: PropTypes.oneOfType([
    PropTypes.shape({
      innerLink: PropTypes.string.isRequired,
      imgSrc: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired
    }),
    PropTypes.shape({
      outterLink: PropTypes.string.isRequired,
      imgSrc: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired
    })
  ]),
  // this is used on responsive to close the sidebar on route navigation
  closeSidebar: PropTypes.func,
  pushRefreshTaskCount: PropTypes.func
};

export default Sidebar;
